// Content for Śrīmad-Bhāgavatam 1.5.8-9 - Why Srila Vyāsadev was Dissatisfied?

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySlokaHeader: 'Śrīmad-Bhāgavatam 1.5.8, 1.5.9',
    primarySloka: {
        reference: 'Śrīmad-Bhāgavatam 1.5.8',
        sloka: `śrī-nārada uvāca—
bhavatānudita-prāyaṁ
yaśo bhagavato 'malam |
yenaivāsau na tuṣyeta
manye tad darśanaṁ khilam ||`,
        translation:
            'Nārada said (<strong>śrī-nāradaḥ uvāca</strong>): You have not sufficiently described (<strong>bhavatā anudita-prāyam</strong>) the glories of the spotless Lord Kṛṣṇa (<strong>bhagavataḥ amalam yaśaḥ</strong>). Because your mind could never be satisfied with Vedānta (<strong>yena eva asau na tuṣyeta</strong>), I think (<strong>manye</strong>) that writing the Vedānta-sūtras is insufficient (<strong>tat darśanam khilam</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                'You have not described much at all (<em>anudita-prāyam</em>) about the spotless glories of the Lord—<strong>the superior position of <em>bhagavān’s</em> forms above all other forms, and the supreme attractiveness of his pastimes and <em>bhakti</em>.</strong>',
        },
        {
            type: 'dialogue',
            objection: '“But I have produced the <em>brahma-mīmāṁsa</em> scripture, the <em>vedānta-darṣana</em>.”',
            response:
                '“I consider that <em>darśana</em> scripture to be deficient (<em>khilam</em>). You are the writer of Vedānta and if your mind is dissatisfied with this, then how will those who continually study this <em>darśana</em> be satisfied? <strong>You are the proof that this <em>darśana</em> is insufficient.</strong>”',
        },
        {
            type: 'text',
            content: '<hr class="my-8 border-gray-300 border-t-2 dark:border-gray-700" />',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Śrīmad-Bhāgavatam 1.5.9',
                sloka: `yathā dharmādayaś cārthā
muni-varyānukīrtitāḥ |
na tathā vāsudevasya
mahimā hy anuvarṇitaḥ ||`,
                translation:
                    'O venerable sage (<strong>muni-varya</strong>)! You have not repeatedly described (<strong>na tathā anuvarṇitaḥ hi</strong>) the glories of Vāsudeva Kṛṣṇa (<strong>vāsudevasya mahimā</strong>) to the extent that you have glorified dharma, artha, kāma and mokṣa (<strong>yathā dharma-ādayaḥ ca arthāḥ anukīrtitāḥ</strong>).',
            },
        },
        {
            type: 'dialogue',
            objection: '“But I have described the wonderful qualities and pastimes of Kṛṣṇa in the Padma Purāṇa and others as well.”',
            response:
                '“The word <em>ca</em> here means ‘though.’ You have not described the glories of Vāsudeva as much as you have described artha, <em>dharma</em>, kāma and <em>mokṣa</em> as the goals of human life (<em>arthā</em>) even though they are much inferior to the glories of Vāsudeva. Though Vāsudeva is the crest jewel of human goals, you have not described him as the goal of human endeavor. <strong>Though you have described the glories of Kṛṣṇa abundantly in many places, they have been described only as a means of getting <em>mokṣa</em>. How can your mind be satisfied when there is a lack of regard for that which should have been given the most regard?</strong>”',
        },
        {
            type: 'text',
            content: '“But I have described bhakti to be higher than liberation in many places in other scriptures.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Padma Purāṇa',
                sloka: `anyatra puṇya-tīrtheṣu
muktir eva mahā-phalam |
muktaiḥ prārthyā harer bhaktir
mathurāyāṁ ca labhyata`,
                translation:
                    'Liberation is the highest goal in visiting other holy places, but devotion to the Lord, prayed for by the liberated souls, can be obtained at Mathurā.',
            },
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Bhagavad-Gītā 18.54',
                sloka: `brahma-bhūtaḥ prasannātmā
na śocati na kāṅkṣati |
samaḥ sarveṣu bhūteṣu
mad-bhaktiṁ labhate parām ||`,
                translation:
                    'One who attains brahman, equal to all living entities, does not lament or desire. He then attains pure devotion to me.',
            },
        },
        {
            type: 'text',
            content:
                '<strong>“But you have not done so repeatedly (<em>na anuvarṇitaḥ</em>).</strong> You must do so, because it is said that the meaning of scriptures is revealed by repetition as in <em>ānandamayo ’bhyāsāt</em>: the <em>ānandamaya-puruṣa</em> is the supreme lord because of repetition of words to indicate this (Vedānta-sūtra 1.1.13). <strong>Your mind will be satisfied only when you describe very clearly with repetition the glories of the Lord, since those glories alone are finally the most excellent.”</strong>',
        },
    ],
};

export default content;